module.exports = __webpack_public_path__ + "img/分子病毒研究员.8d6fc171.jpg";